import React, { useEffect, useState } from "react";
import { photos } from "../../data/photos";

function Photography() {
  const [activeIndex, setActiveIndex] = useState(null);
  const active = activeIndex === null ? null : photos[activeIndex];

  useEffect(() => {
    if (activeIndex === null) return undefined;

    function onKey(event) {
      if (event.key === "Escape") setActiveIndex(null);
      if (event.key === "ArrowRight") {
        setActiveIndex((index) => (index + 1) % photos.length);
      }
      if (event.key === "ArrowLeft") {
        setActiveIndex((index) => (index - 1 + photos.length) % photos.length);
      }
    }

    document.addEventListener("keydown", onKey);
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", onKey);
      document.body.style.overflow = previousOverflow;
    };
  }, [activeIndex]);

  return (
    <main className="page page--interior page--photos">
      <header className="page-header">
        <p className="section-kicker">Photography</p>
        <h1 className="section-title">Things I have been looking at!</h1>
        <p className="page-lead">A few pictures I have taken over the years :)</p>
      </header>

      {photos.length === 0 ? (
        <p className="photo-empty">
          No photos yet. Drop .jpg, .png, or .webp files into src/Assets/Photography, then refresh.
        </p>
      ) : (
        <div className="photo-collage">
          {photos.map((photo, index) => (
            <button
              key={photo.id}
              type="button"
              className="photo-card"
              onClick={() => setActiveIndex(index)}
            >
              <img src={photo.src} alt="" />
            </button>
          ))}
        </div>
      )}

      {active && (
        <div className="photo-lightbox" onClick={() => setActiveIndex(null)} role="presentation">
          <figure className="photo-lightbox-frame" onClick={(event) => event.stopPropagation()}>
            <img src={active.src} alt="" />
          </figure>
          <button
            type="button"
            className="photo-lightbox-close"
            onClick={() => setActiveIndex(null)}
            aria-label="Close photo"
          >
            Close
          </button>
        </div>
      )}
    </main>
  );
}

export default Photography;
